/**
 * @deprecated Do not use legacy components anymore.
 */
export var FormBoxEnums;
(function (FormBoxEnums) {
    FormBoxEnums["confirmationPrompt"] = "Are you sure you want to close this form?\nAny unsaved changes will be lost!";
})(FormBoxEnums || (FormBoxEnums = {}));
//# sourceMappingURL=FormBoxEnums.js.map